/**
 * Chart.js plugin that draws a total label above the tallest stacked bar
 * when the user hovers over an x-axis tick label.
 */
export const stackTotalsPlugin = {
  id: "stackTotals",

  afterEvent(chart, args) {
    const { event } = args;
    const prev = chart._stackHoverIdx;

    if (event.type === "mousemove") {
      const { x, y } = event;
      const { chartArea, scales } = chart;

      if (y > chartArea.bottom) {
        const xScale = scales.x;
        let nearest = null;
        let minDist = Infinity;
        xScale.ticks.forEach((_, i) => {
          const dist = Math.abs(x - xScale.getPixelForTick(i));
          if (dist < minDist) {
            minDist = dist;
            nearest = i;
          }
        });
        chart._stackHoverIdx = minDist < 50 ? nearest : null;
      } else {
        chart._stackHoverIdx = null;
      }
    } else {
      chart._stackHoverIdx = null;
    }

    if (chart._stackHoverIdx !== prev) args.changed = true;
  },

  afterDraw(chart) {
    const idx = chart._stackHoverIdx;
    if (idx == null) return;

    const { ctx, data, scales } = chart;
    const total = data.datasets.reduce(
      (sum, ds) => sum + (ds.data[idx] || 0),
      0
    );
    if (!total) return;

    const x = scales.x.getPixelForTick(idx);
    const y = scales.y.getPixelForValue(total);
    const label = String(total);

    ctx.save();
    ctx.font = "600 12px Inter, sans-serif";

    const padX = 8;
    const boxW = ctx.measureText(label).width + padX * 2;
    const boxH = 22;
    const boxX = x - boxW / 2;
    const boxY = y - boxH - 6;
    const r = 6;

    ctx.fillStyle = "#1C0F30";
    ctx.beginPath();
    ctx.moveTo(boxX + r, boxY);
    ctx.lineTo(boxX + boxW - r, boxY);
    ctx.quadraticCurveTo(boxX + boxW, boxY, boxX + boxW, boxY + r);
    ctx.lineTo(boxX + boxW, boxY + boxH - r);
    ctx.quadraticCurveTo(
      boxX + boxW,
      boxY + boxH,
      boxX + boxW - r,
      boxY + boxH
    );
    ctx.lineTo(boxX + r, boxY + boxH);
    ctx.quadraticCurveTo(boxX, boxY + boxH, boxX, boxY + boxH - r);
    ctx.lineTo(boxX, boxY + r);
    ctx.quadraticCurveTo(boxX, boxY, boxX + r, boxY);
    ctx.closePath();
    ctx.fill();

    ctx.fillStyle = "#ffffff";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(label, x, boxY + boxH / 2);
    ctx.restore();
  },
};
